export const namespace = 'tickerRating'
